export default __webpack_public_path__ + "static/media/datePicker-icon.6a7c36d8.svg";